import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const location = useLocation();
  const { user } = useAuth();

  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: 'fas fa-th-large' },
    { name: 'Pipeline', href: '/pipeline', icon: 'fas fa-stream' },
    { name: 'Performance', href: '/performance', icon: 'fas fa-chart-line' },
    { name: 'Audience', href: '/audience', icon: 'fas fa-users' },
    { name: 'Calendar', href: '/calendar', icon: 'fas fa-calendar-alt' },
    { name: 'Settings', href: '/settings', icon: 'fas fa-cog' },
  ];

  const isActive = (href) => {
    return location.pathname === href || (href === '/dashboard' && location.pathname === '/');
  };

  return (
    <>
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-gray-900/75 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-50 w-64 bg-white border-r border-gray-200 transform transition-transform duration-300 ease-in-out
        lg:translate-x-0 lg:static lg:inset-0
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
        <div className="flex items-center justify-center h-28 px-4 border-b border-gray-200">
          <div className="flex items-center">
            <img src="/logo.png" alt="Socialite" className="h-28" />
          </div>
        </div>

        <nav className="mt-8 px-4">
          <div className="space-y-2">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`
                  group flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-colors duration-150
                  ${isActive(item.href)
                    ? 'bg-accent-100 text-accent-900'
                    : 'text-gray-600 hover:bg-accent-50 hover:text-gray-900'
                  }
                `}
                onClick={() => setSidebarOpen(false)}
              >
                <i className={`${item.icon} w-5 h-5 mr-3 flex-shrink-0`}></i>
                {item.name}
              </Link>
            ))}
          </div>
        </nav>

        {/* User section at bottom */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200">
          <div className="flex items-center">
            <img
              className="w-10 h-10 rounded-full"
              src={`https://ui-avatars.com/api/?name=${encodeURIComponent(user?.first_name || user?.username || 'User')}&background=6b7280&color=fff`}
              alt="User avatar"
            />
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-700">
                {user?.first_name && user?.last_name
                  ? `${user.first_name} ${user.last_name}`
                  : user?.username || 'User'
                }
              </p>
              <p className="text-xs text-gray-500">
                {user?.is_superuser ? 'Administrator' : 'User'}
              </p>
            </div>
          </div>
          <p className="text-xs text-gray-300 mt-2 text-center">v0.4.0</p>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
